import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {Attachment, AttachmentParams, NachdigalService} from '@nachdigal';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  // This would be overriden by config from Backend
  public backendConfig = {
    document_count: 20,
    document_size: 10000000,
    all_documents_size: 20971520,
    document_name_length: 46,
    document_max_page_count: 100
  };
  constructor(private readonly nachdigalService: NachdigalService) {
  }

  attachments = new BehaviorSubject<Attachment[]>([]);
  loadedTaskId: string = null;

  public load(taskId) {
    if (!this.attachments.value || this.loadedTaskId !== taskId) {
      return this.reload(taskId);
    } else {
      return new Observable<Attachment[]>(sub => sub.next(this.attachments.value));
    }
  }

  public reload(taskId) {
    this.loadedTaskId = taskId;
    return this.nachdigalService.getAttachments(taskId).pipe(map(at => at.documents), tap(d => this.attachments.next(d)));
  }

  public deleteAttachment(taskId, documentId) {
    if (taskId !== this.loadedTaskId) {
      this.attachments.error(`delete, unexpedted taskid ${taskId} ${this.loadedTaskId}`)
    }
    return this.nachdigalService.deleteAttachment(taskId, documentId).pipe(tap(
      () => this.attachments.next(this.attachments.value.filter(d => d.doc_id !== documentId))
    ));
  }

  public postAttachment(taskId: string, data, params: AttachmentParams) {
    if (taskId !== this.loadedTaskId) {
      this.attachments.error(`post, unexpected taskid ${taskId} ${this.loadedTaskId}`)
    }
    return this.nachdigalService.postAttachment(taskId, data, params).pipe(tap(
      newDoc => this.attachments.next([newDoc, ...this.attachments.getValue()]))
    );
  }

  public getUserEmail(taskId: string) {
     return this.nachdigalService.getUserEmail(taskId);
  }

  public saveUserEmail(taskId: string, userName: string) {
     return this.nachdigalService.saveUserEmail(taskId, userName);
  }
}
